<div class="box sepa-input-box" [formGroup]="sepaFormGroup()">
  <h3>Wie lautet Ihre IBAN?</h3>
  <p>Zum Schluss benötigen wir noch Ihre Bankverbindung.</p>

  <ez-iban-input name="iban" controlName="iban"> </ez-iban-input>

  @if (showPopover()) {
    <ez-popover class="popover-component" [referenceEl]="anchor()" (outsideClick)="showPopover.set(false)">
      <p>
        Im Zuge des einheitlichen Euro-Zahlungsverkehrs (SEPA) gibt es für jeden Zahlungsempfänger eine
        Gläubiger-Identifikationsnummer. Zusammen mit der Mandatsreferenz, die wir Ihnen gesondert mitteilen, ist eine
        eindeutige Identifizierung des (SEPA-)Lastschriftmandats gegeben. Unsere Gläubiger-Identifikationsnummer
        (CI/Creditor Identier) für die R+V Allgemeine Versicherung AG lautet: DE63001000000136090.
      </p>

      <p>
        Ich ermächtige Sie, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein
        Kreditinstitut an, die von Ihnen auf mein Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann innerhalb
        von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrags verlangen. Es gelten
        dabei die mit meinem Kreditinstitut vereinbarten Bedingungen. Vor der SEPA-Lastschrift informiert der
        Zahlungsempfänger über Abbuchungstermin und Betrag. Ich möchte meine Angaben elektronisch übermitteln und
        verzichte daher auf ein schriftliches SEPA-Mandat.
      </p>
    </ez-popover>
  }

  <ez-checkbox-input name="sepa-mandate" controlName="givesSepaMandate">
    Hiermit erteile ich der R+V Allgemeine Versicherung AG ein
    <a href="javascript:void(0)" class="text--bold" (click)="onClickSepaInfo()" #sepaInfo>SEPA-Lastschriftmandat</a>, um
    fällige Zahlungen von meinem Konto einzuziehen.
  </ez-checkbox-input>

  <ez-button label="Weiter" (buttonClick)="onSubmit()" [disabled]="sepaFormGroup().invalid"></ez-button>
  @if (errorMessage(); as _message) {
    <span class="error-message">{{ _message }}</span>
  }

  <ez-button
    theme="secondary"
    label="Zurück zur Zahlungsübersicht"
    buttonType="button"
    (buttonClick)="onBackToOverview()"
  ></ez-button>
</div>
